import { ReconciliationSuggestion } from '@modules-deprecated/bankReconciliation/types'

import { BookkeepingItem } from '../types/bookkeepingItem'
import { isCashBasedNonExactSuggestion } from './isCashBasedNonExactSuggestion'
import { validateSuggestion } from './validateSuggestion'

export const getSuggestionsByBankLineId = (
  suggestions?: ReconciliationSuggestion[] | Record<string, ReconciliationSuggestion>,
  bookkeepingItems?: BookkeepingItem[],
): Map<string, ReconciliationSuggestion> => {
  const map = new Map<string, ReconciliationSuggestion>()

  if (!suggestions) {
    return map
  }

  for (const suggestion of Object.values(suggestions)) {
    const bookkeepingItem = validateSuggestion(suggestion, bookkeepingItems)

    if (!bookkeepingItem || isCashBasedNonExactSuggestion(suggestion, bookkeepingItem.accountingBasis)) {
      continue
    }

    // A single suggestion can cover multiple combined bank lines, so every transaction needs its own map entry.
    for (const transaction of suggestion.transactions) {
      if (transaction.id) {
        map.set(transaction.id, suggestion)
      }
    }
  }

  return map
}
